module.exports = __webpack_public_path__ + "static/PhotoCollage-a9d408d4566027d9d3e66635a78d43e4.png";